import { Injectable } from '@angular/core';
import { BehaviorSubject, skip } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventsWyswygService {
  private elementDeletedEvent = new BehaviorSubject<string>('');
  private elementDuplicatedEvent = new BehaviorSubject<string>('');
  private answerSavedEvent = new BehaviorSubject<string>('');
  private focusModeSubject = new BehaviorSubject<boolean>(false);
  focusMode$ = this.focusModeSubject.asObservable();
  
  constructor() { }

  // Event handling methods
  // usamos BehaviorSubject para emitir eventos entre componentes muy anidados
  // el componente que deba escuchar los eventos, se suscribe al Listener
  onElementDeleted(prefix: string) {
    this.elementDeletedEvent.next(prefix);
  }

  deleteElementEventListener() {
    return this.elementDeletedEvent.asObservable().pipe(
      skip(1) // when we subscribe to BehaviorSubject, a first empty value is emmitted
    );
  }

  onElementDuplicated(prefix: string) {
    this.elementDuplicatedEvent.next(prefix);
  }

  duplicateElementEventListener() {
    return this.elementDuplicatedEvent.asObservable().pipe(
      skip(1) // when we subscribe to BehaviorSubject, a first empty value is emmitted
    );
  }

  onAnswerSaved(id: string) {
    this.answerSavedEvent.next(id);
  }

  answerSavedEventListener() {
    return this.answerSavedEvent.asObservable().pipe(
      skip(1) // when we subscribe to BehaviorSubject, a first empty value is emmitted
    );
  }

  emitFocusMode(active: boolean) {
    this.focusModeSubject.next(active);
  }
}
